import Swiper, {
  Navigation, Pagination, Scrollbar, Autoplay,
} from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

/**
 * Слайдер фотографий на странице Клиники.
 * @constructor
 */
export default function PhotoGallerySlider() {
  // eslint-disable-next-line no-new
  new Swiper('.photo-gallery-slider .swiper', {
    direction: 'horizontal',
    rewind: true,
    slidesPerView: 1,
    spaceBetween: 10,
    draggable: true,
    preloadImages: false,
    freeMode: {
      enabled: false,
      sticky: false,
    },
    navigation: {
      nextEl: '.photo-gallery-slider .slide-next',
      prevEl: '.photo-gallery-slider .slide-prev',
    },
    breakpoints: {
      635: {
        slidesPerView: 2,
      },
    },
  });
}
